module.exports = __webpack_public_path__ + "static/media/new_snow.15cebf5f.svg";